<template>
  <div>
    <div v-if="portalType === 'login'">
      <div class="copy">
        <slot name="login-copy">
          <h2>Log In</h2>
          <p>Sign in to your account</p>
        </slot>
      </div>
      <div class="form-wrap" :class="size">
        <login-form></login-form>
      </div>
      <p v-if="forgot" class="fine-print-lg">I forgot <a href="/account/forgot"> my password</a>.</p>
      <p v-if="type" class="mtop-20">Don't have a TunnelBear account? <button class="plain link" @click="currentFace = 'signup'">Sign&nbsp;up</button></p>
      <p v-else class="mtop-20">Don't have a TunnelBear account? <router-link :to="{ name: 'signup', query: $route.query}" class="plain link">Sign&nbsp;up</router-link></p>
    </div>
    <div v-else>
      <div class="copy">
        <slot name="signup-copy">
          <h2>You're almost there</h2>
          <p>Sign up to get TunnelBear</p>
        </slot>
      </div>
      <div class="form-wrap" :class="size">
        <signup-form></signup-form>
      </div>
      <p v-if="type" class="mtop-10">Or <button class="plain link" @click="currentFace = 'login'">use an existing account</button></p>
      <p v-else class="mtop-20">Or <router-link class="plain link" :to="{ name: 'login', query: $route.query}">use an existing account</router-link></p>
    </div>
  </div>
</template>

<script>
import loginForm from '@/components/login-form/login-form'
import signupForm from '@/components/signup-form/signup-form'

export default {
  name: 'portal',
  props: ['forgot', 'type', 'size'],
  components: {
    'login-form': loginForm,
    'signup-form': signupForm
  },
  data () {
    return {
      currentFace: this.type
    }
  },
  computed: {
    portalType: function () {
      return this.type ? this.currentFace : this.$route.name
    }
  }
}
</script>

<style scoped lang="stylus" src="./portal.styl" >



// WEBPACK FOOTER //
// src/components/portal/portal.vue